<div class="container-view">
  <!-- <app-header-register *ngIf="header === 'register' || header === 'recover'"> </app-header-register>
  <app-header-login *ngIf="header === 'login'"></app-header-login>
  <app-header-landing *ngIf="header !== 'login' && header !== 'code' && header !== 'register' && header !== 'recover'"> </app-header-landing> -->

  <main class="authentication">
    <router-outlet></router-outlet>
  </main>
</div>
